<template>
	<div>
		<div v-if="!passwordVerified">
			<PasswordInput @passwordCorrect="passwordVerified = true" />
		</div>
		<Card v-else>
			<div>
				<div>
					<div style="width: 850px">
						<DatePicker type="daterange" :value="quotationTime" @on-change="quotationTimeChange"
							placeholder="录入报价时间" style="width: 200px"></DatePicker>
						<Input v-model="quotationAdvCidName" style="width: 150px;margin-left: 10px;" placeholder="渠道名称"
							@on-change="quotationSearch" />
						<Select v-model="quotationAdvCity" style="width: 100px;margin-left: 10px;"
							@on-change="quotationSearch">
							<Option v-for="item in cityList" :value="item.city" :key="item.city">
								{{ item.city}}
							</Option>
						</Select>
						<Select v-model="quotationAdvOrderType" style="width: 100px;margin-left: 10px;"
							@on-change="quotationSearch">
							<Option v-for="item in advOrderTypeList" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
						<!--Button type="primary" @click="quotationSearch" style="margin-left: 10px;">搜索</Button-->
						<Button type="primary" @click="initquotationAdvSearch" style="margin-left: 10px;">重置</Button>
						<Button type="primary" @click="exportData" style="margin-left: 10px;">导出表格</Button>
					</div>
				</div>
				<div style="width: 100%;padding-top: 20px;">
					<!--Button type="primary" @click="addQuotationMadal()">生成报价成本</Button-->
					<Button type="primary" @click="addAdvCostMadal()" style="margin-left: 10px;">添加投放成本</Button>
					<Button type="primary" @click="addDefauleCostMadal()" style="margin-left: 10px;">设置默认出价</Button>
					<Button type="primary" @click="settleCost" style="margin-right: 50px;float: right;"
						v-if="settleStatus == 0 && userInfo.role_type == 1">点击结算</Button>
					<Button type="primary" @click="saveQuotationList"
						style="margin-right: 50px;float: right;">保存</Button>
				</div>
				<div style="width: 100%;padding-top: 20px;color: red;font-size: 20px;"
					v-if="missingDates.length > 0 && missingDates != undefined">
					<!--Button type="primary" @click="addQuotationMadal()">生成报价成本</Button-->
					<span style="color: red;">有尚未结算日期</span><span
						v-for="(missingDate, index) in missingDates">({{missingDate}})</span>
				</div>
				<div style="height: 600px; overflow-y: auto; overflow-x: hidden;margin-top: 20px;">
					<Table :columns="quotationColumns" :data="quotationData" size="small" ref="mytable">
						<template slot-scope="{ row,index }" slot="quotation_average_money">
							<Input v-model="quotationData[index].quotation_average_money" v-if="settleStatus == 0"
								@on-change="changeQuotationAverageMoney($event, index)" style="width: 60px" />
							<span v-else>{{quotationData[index].quotation_average_money}}</span>
						</template>
						<template slot-scope="{ row,index }" slot="quotation_money">
							<Input v-model="quotationData[index].quotation_money" v-if="settleStatus == 0"
								@on-change="changeQuotationCost($event, index)" style="width: 60px" />
							<span v-else>{{quotationData[index].quotation_money}}</span>
						</template>
						<template slot-scope="{ row,index }" slot="earn_money">
							<span>{{(quotationData[index].quotation_money-quotationData[index].adv_money).toFixed(2)}}</span>
						</template>
						<template slot-scope="{ row, index }" slot="action">
							<Button type="primary" size="small" style="margin-right: 5px"
								:data-channel_id="row.client_id" :data-city="row.city" :data-index="index"
								v-if="settleStatus == 1" @click="editQuotation">修改报价</Button>
						</template>
					</Table>
				</div>
			</div>
			<div class="pager">
				<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
					:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small"
					show-elevator />
			</div>
			<Modal v-model="editQuotationModal" width="500" title="修改报价">
				<Form :label-width="120">
					<FormItem label="城市">
						<span>{{quotationForm.city}}</span>
					</FormItem>
					<FormItem label="数量">
						<span>{{quotationForm.form_nums}}</span>
					</FormItem>
					<FormItem label="时间">
						<span>{{quotationForm.quotation_time}}</span>
					</FormItem>
					<FormItem label="修改前单价">
						<span>{{quotationForm.quotation_average_money}}</span>
					</FormItem>
					<FormItem label="修改前消耗">
						<span>{{quotationForm.quotation_money}}</span>
					</FormItem>
					<FormItem label="修改后单价">
						<Input placeholder="修改后单价" v-model="quotationForm.edit_quotation_average_money"
							@on-change="changeQuotationForm"></Input>
					</FormItem>
					<FormItem label="修改后消耗">
						<Input placeholder="修改后消耗" v-model="quotationForm.edit_quotation_money"
							@on-change="changeAverageQuotationForm"></Input>
					</FormItem>
				</Form>
				<div slot="footer">
					<Button type="primary" @click="quotationFormSubmmit">提交</Button>
					<Button type="default" @click="editQuotationModal = false">取消</Button>
				</div>
			</Modal>
			<Modal title="投放成本录入" v-model="advCostModal" @on-cancel="() => {advCostModal = false}" width="1000px">
				<div>
					<div style="">
						<div style="width: 500px;" class="yl-flex flex_between">
							<DatePicker type="daterange" :value="advTime" @on-change="advTimeChange"
								placeholder="录入成本时间" style="width: 200px"></DatePicker>
							<Input v-model="advCidName" style="width: 150px;margin-left: 10px;" @on-change="advSearch"
								placeholder="渠道名称" />
							<Select v-model="advCity" style="width: 100px;margin-left: 10px;" @on-change="advSearch">
								<Option v-for="item in cityList" :value="item.city" :key="item.city">
									{{ item.city}}
								</Option>
							</Select>
							<Select v-model="advOrderType" @on-change="advSearch"
								style="width: 100px;margin-left: 10px;">
								<Option v-for="item in advOrderTypeList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>

						</div>
						<div style="width: 500px;" class="yl-flex flex_between">
							<Button type="primary" @click="advSearch" style="margin-left: 10px;">搜索</Button>
							<Button @click="initAdvSearch" style="margin-left: 10px;">重置</Button>
							<Button @click="generationCost" style="margin-left: 10px;">广告成本生成</Button>
							<Button @click="r360GenerationCost" style="margin-left: 10px;">融360成本</Button>
							<Button @click="tencentGenerationCost" style="margin-left: 10px;">腾讯成本</Button>
						</div>
						<div style="display: block;font-size: 0;clear: both;height: 20px;">
							<Button type="primary" @click="saveAdvMessage"
								style="margin-right: 50px;float: right;">保存</Button>
						</div>
					</div>

					<div style="height: 600px; overflow-y: auto; overflow-x: hidden;margin-top: 20px;">
						<Table :columns="advColumns" :data="advData" size="small" ref="table">
							<template slot-scope="{ row,index }" slot="form_cost">
								<Input v-model="advData[index].form_cost" @on-change="changeFormCost($event, index)"
									style="width: 60px" />
							</template>
							<template slot-scope="{ row,index }" slot="adv_cost">
								<Input v-model="advData[index].adv_cost" @on-change="changeAdvCost($event, index)"
									style="width: 80px" />
							</template>
						</Table>
					</div>
				</div>
			</Modal>
			<Modal title="默认出价设置" v-model="defaultCostModal" @on-cancel="() => {defaultCostModal = false}"
				width="1000px">
				<div style="width: 450px" class="yl-flex flex_between">
					<Input v-model="defaultCostCidName" placeholder="请输入渠道名称" />
					<Button type="primary" @click="getDefaultAdvCost" style="margin-left: 10px;">搜索</Button>
					<Button @click="initDefaultCostSearch" style="margin-left: 10px;">重置</Button>
					<Button type="primary" @click="addSingleDefaultCost" style="margin-left: 10px;">添加默认报价</Button>
				</div>
				<div style="width: 100% ;margin-top: 20px;">

					<Table :columns="defaultColumns" :data="defaultData" size="small" ref="table">
						<template slot-scope="{ row,index }" slot="form_cost">
							<Input v-model="defaultData[index].form_cost" @on-change="changeFormCost($event, index)"
								style="width: 60px" />
						</template>
						<template slot-scope="{ row,index }" slot="adv_cost">
							<Input v-model="defaultData[index].defult_form_cost"
								@on-change="changeAdvCost($event, index)" style="width: 60px" />
						</template>
						<template slot-scope="{ row, index }" slot="action">
							<Button type="primary" size="small" style="margin-right: 5px" :data-id="row.id"
								:data-index="index" @click="saveDefaultCost">保存</Button>
							<Button type="error" size="small" :data-id="row.id" @click="delDefaultCost">删除</Button>
						</template>
					</Table>
				</div>
				<div>
					<Page show-total :total="defaultCostCount" show-sizer :page-size="defaultCostPageSize"
						:page-size-opts="pageSizeOpts" :current="defaultCostPage" @on-change="defaultCostChangePage"
						@on-page-size-change="defaultCostChangeSize" size="small" show-elevator />
				</div>
			</Modal>
			<Modal v-model="addSingleDefaultCostModal" title="添加默认报价" @on-ok="saveSingleDefaultCost">
				<Form :model="formItem" :label-width="100">
					<FormItem label="渠道">
						<Select v-model="formItem.cid">
							<Option v-for="item in cidList" :value="item.id" :key="item.id">
								{{ item.username }}-[cid:{{item.id}}]
							</Option>
						</Select>
					</FormItem>
					<FormItem label="城市">
						<Input v-model="formItem.city">
						</Input>
					</FormItem>
					<FormItem label="价格">
						<Input v-model="formItem.defult_form_cost">
						</Input>
					</FormItem>
				</Form>
			</Modal>
		</Card>
	</div>

</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		saveAdvCity,
		getAdvMessage,
		saveAdvMessage,
		getQuotationList,
		saveQuotationList,
		getAdvCostList,
		getDefaultAdvCost,
		getCidList,
		saveSingleDefaultCost,
		delDefaultCost,
		getAdvCity,
		settleCost,
		getQuotation,
		quotationFormSubmmit,
		generationCost,
		getNotSettleDays,
		r360GenerationCost,
		tencentGenerationCost
	} from "../../api/runSet";
	import PasswordInput from '../tool/PasswordInput.vue';
	import cityData from "../../assets/citydata";

	export default {
		name: "advertising_manage",
		components: {
			PasswordInput
		},

		data() {
			return {
				exportdata: [],
				quotationAdvCidName: '',
				quotationAdvCity: '',
				quotationAdvOrderType: 1,
				editQuotationModal: false,
				advCidName: '',
				advCity: '',
				showCity: false,
				cityList: [],
				cityData: cityData,
				advOrderType: 1,
				AdvCostList: [],
				modal: false,
				name: '',
				quotationModal: false,
				advCostModal: false,
				defaultCostModal: false,
				is_select_date: false,
				quotationTime: '',
				advTime: '',
				searchTime: '',
				count: 0,
				defaultCostCount: 0,
				advOrderTypeList: [{
						value: 1,
						label: '渠道排序'
					},
					{
						value: 2,
						label: '城市排序'
					}
				],
				cidList: [],
				page: 1,
				pageSize: 10,
				defaultCostPage: 1,
				defaultCostPageSize: 10,
				pageSizeOpts: [10, 50, 100, 500],
				city: [],
				datas: [],
				quotationForm: {

				},
				quotationData: [],
				settleStatus: 0,
				missingDates: [],
				advData: [],
				defaultData: [],
				defaultCostCidName: '',
				addSingleDefaultCostModal: false,
				passwordVerified: false,
				formItem: {
					cid: '',
					city: '',
					defult_form_cost: '',
				},
				formData: {
					city: ''
				},
				columns: [{
						"title": "投放平台",
						"key": "cid_name",
						"align": 'center',
					},
					{
						"title": "投放平台id",
						"key": "cid",
						"align": 'center',
					},
					{
						"title": "客户",
						"key": "client_name",
						"align": 'center',
					},
					{
						"title": "客户id",
						"key": "client_id",
						"align": 'center',
					},
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "表单数量",
						"key": "form_nums",
						"align": 'center',
					},
					{
						"title": "报价成本",
						"key": "quotation_average_money",
						"align": 'center',
					},
					{
						"title": "投放成本",
						"key": "form_cost",
						"align": 'center',
					},
					{
						"title": "收入",
						"key": "quotation_money",
						"align": 'center',
					},
					{
						"title": "消耗",
						"key": "adv_cost",
						"align": 'center',
					},
					{
						"title": "收益",
						"slot": "earn_money",
						"align": 'center',
					},
				],
				quotationColumns: [{
						"title": "序号",
						"type": "index",
						"align": 'center',
						"width": '50px',
					},
					{
						"title": "客户id",
						"key": "client_id",
						"align": 'center',
					}, {
						"title": "客户",
						"key": "client_name",
						"align": 'center',
					},
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "表单数量",
						"key": "form_nums",
						"align": 'center',
					},
					{
						"title": "报价单价",
						"slot": "quotation_average_money",
						"align": 'center',
					},
					{
						"title": "投放单价",
						"key": "adv_average_money",
						"align": 'center',
					},
					{
						"title": "报价消耗",
						"slot": "quotation_money",
						"align": 'center',
					},
					{
						"title": "投放消耗",
						"key": "adv_money",
						"align": 'center',
					},
					{
						"title": "差值",
						"slot": "earn_money",
						"align": 'center',
					},
					{
						"title": "余额",
						"key": "balance",
						"align": 'center',
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				advColumns: [{
						type: 'selection',
						align: 'center'
					},
					{
						"title": "渠道",
						"key": "cid_name",
						"align": 'center',
					},
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "表单数量",
						"key": "form_nums",
						"align": 'center',
					},
					{
						"title": "投放成本",
						"slot": "form_cost",
						"align": 'center',
					},
					{
						"title": "投放消耗",
						"slot": "adv_cost",
						"align": 'center',
					},
				],
				defaultColumns: [{
						"title": "渠道",
						"key": "cid_name",
						"align": 'center',
					},
					{
						"title": "cid",
						"key": "cid",
						"align": 'center',
					},
					{
						"title": "城市",
						"key": "city",
						"align": 'center',
					},
					{
						"title": "默认出价",
						"slot": "adv_cost",
						"align": 'center',
					},
					{
						title: 'Action',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.initDate();
			this.getList();
			this.getDefaultAdvCost();
			this.loadData();
		},
		watch: {
			$route() { // 监听路由变化  // 组件第一次进入不会执行
				this.passwordVerified = false;
			},
		},
		methods: {
			initDate() {
				const myDate = new Date();
				myDate.setTime(myDate.getTime() - 24 * 60 * 60 * 1000);
				const year = myDate.getFullYear(); // 获取当前年份
				const month = myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
				const day = myDate.getDate(); // 获取当前日（1-31）
				// 日期格式：2019/07/29 - 2019/07/29
				this.searchTime = `${year}/${month}/${day} - ${year}/${month}/${day}`;
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAdvCity(that, data);
				that.cityList = res.data.list;
				res = await getNotSettleDays(that, data);
				that.missingDates = res.data.notSettleDays;
				console.log(this.missingDates)
			},
			mySearch(e) {
				this.advCity = e;
			},
			initSearch() {
				this.name = '';
				this.initDate();
				this.quotationDefalutDay();
				this.is_select_date = false;
				this.getList();
			},
			initAdvSearch() {
				this.advCidName = '';
				this.advCity = '';
				this.advOrderType = 1;
				this.advSearch();
			},
			initquotationAdvSearch() {
				this.quotationAdvCidName = '';
				this.quotationAdvCity = '';
				this.quotationAdvOrderType = 1;
				this.quotationSearch();
			},
			initDefaultCostSearch() {
				this.defaultCostCidName = '';
				this.defaultCostPage = 1;
				this.defaultCostPageSize = 10;
				this.getDefaultAdvCost();
			},
			async getDefaultAdvCost() {
				let that = this;
				let data = {}
				data.defaultCostCidName = that.defaultCostCidName;
				data.defaultCostPageSize = this.defaultCostPageSize;
				data.token = this.token;
				data.defaultCostPage = this.defaultCostPage;
				let res = await getDefaultAdvCost(that, data);
				that.defaultData = res.data.list;
				that.defaultCostCount = res.count;
			},
			addSingleDefaultCost() {
				this.getCidList();
				this.addSingleDefaultCostModal = true;
			},
			async editQuotation(e) {
				let that = this;
				let channel_id = e.currentTarget.dataset.channel_id;
				let city = e.currentTarget.dataset.city;
				let date_time = that.quotationTime;
				let data = {
					token: that.token,
					channel_id: channel_id,
					city: city,
					date_time: date_time,
				};
				let res = await getQuotation(that, data);
				if (res.code == 1) {
					that.quotationForm = res.data.item;
					that.editQuotationModal = true;
				}
			},
			async quotationFormSubmmit() {
				let that = this;
				let data = {
					token: that.token,
					quotationForm: that.quotationForm,
				};
				let res = await quotationFormSubmmit(that, data);
				if (res.code == 1) {
					this.editQuotationModal = false;
					this.quotationSearch();
				}
			},
			async getCidList() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getCidList(that, data);
				that.cidList = res.data.list;
			},
			addQuotationMadal() {
				this.quotationModal = true;
			},
			addAdvCostMadal() {
				this.advCostModal = true;
			},
			addDefauleCostMadal() {
				this.defaultCostModal = true;
			},
			async getList() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.searchTime = this.searchTime;
				let res = await getAdvCostList(that, data);
				this.datas = res.data.list;
			},
			changePage() {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			defaultCostChangePage(e) {
				this.defaultCostPage = e;
				this.getDefaultAdvCost();
			},
			defaultCostChangeSize(e) {
				this.defaultCostPageSize = e;
				this.getDefaultAdvCost();
			},
			search() {
				this.getList();
			},
			quotationTimeChange(e) {
				this.quotationTime = e;
				this.is_select_date = true;
				this.quotationSearch();
			},
			advTimeChange(e) {
				this.advTime = e;
				this.is_select_date = true;
				this.advSearch();
			},
			//时间搜索改变
			searchTimeChange(e) {
				this.searchTime = e;
				this.is_select_date = true;
			},
			async quotationSearch() {
				let that = this;
				let data = {}
				data.token = this.token;
				data.quotationTime = this.quotationTime;
				data.quotationAdvCity = that.quotationAdvCity;
				data.quotationAdvCidName = that.quotationAdvCidName;
				data.quotationAdvOrderType = that.quotationAdvOrderType;
				let res = await getQuotationList(that, data);
				this.quotationData = res.data.list;
				this.settleStatus = res.data.settleStatus;
				this.loadData();
			},
			async advSearch() {
				let that = this;
				let data = {}
				data.token = that.token;
				data.advTime = that.advTime;
				data.advCity = that.advCity;
				data.advCidName = that.advCidName;
				data.advOrderType = that.advOrderType;
				let res = await getAdvMessage(that, data);
				that.advData = res.data.list;
			},
			async generationCost() {
				let that = this;
				let data = {}
				data.token = that.token;
				data.advTime = that.advTime;
				data.advCity = that.advCity;
				data.advCidName = that.advCidName;
				data.advOrderType = that.advOrderType;
				that.advCidName = "今日头条";
				let res = await generationCost(that, data);
				that.advData = res.data.list;
			},

			async r360GenerationCost() {
				let that = this;
				let data = {}
				data.token = that.token;
				data.advTime = that.advTime;
				data.advCity = that.advCity;
				data.advCidName = that.advCidName;
				data.advOrderType = that.advOrderType;
				that.advCidName = "融360";
				let res = await r360GenerationCost(that, data);
				that.advData = res.data.list;
			},
			async tencentGenerationCost() {
				let that = this;
				let data = {}
				data.token = that.token;
				data.advTime = that.advTime;
				data.advCity = that.advCity;
				data.advCidName = that.advCidName;
				data.advOrderType = that.advOrderType;
				that.advCidName = "朋友圈";
				let res = await tencentGenerationCost(that, data);
				that.advData = res.data.list;
			},			
			saveAdvMessage() {
				let that = this;
				var data = that.advData;
				//遍历下看是否有0的成本
				let arr = data;
				for (let i = 1, len = arr.length; i < len; i++) {
					if (arr[i].adv_cost == 0) {
						that.$Message.error('还有成本为0的数据，请检查');
						return;
					}
				}
				that.$Modal.confirm({
					title: '确定保存吗？',
					onOk: async () => {
						that.throttle(async function() {
							let advData = data;
							let advTime = that.advTime;
							advData.shift(); //去掉数组第一项合计项
							let res = await saveAdvMessage(that, {
								list: advData,
								advTime: advTime,
								token: that.token,
							});
							if (res.code == 1) {
								that.$Message.success(res.msg);
								that.advSearch();
							}
						}, 500)
					}
				})
			},
			async saveSingleDefaultCost() {
				let that = this;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: that.formItem
					};
					let res = await saveSingleDefaultCost(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						this.getDefaultAdvCost();
					}
				}, 500)
			},
			delDefaultCost(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认要删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								id: id
							}
							data.token = this.token;
							let res = await delDefaultCost(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
								this.getDefaultAdvCost();
							}
						}, 500)
					}
				})
			},
			saveDefaultCost(e) {
				let that = this;
				let index = e.currentTarget.dataset.index;
				that.throttle(async function() {
					let data = {
						token: that.token,
						data: {
							id: that.defaultData[index].id,
							city: that.defaultData[index].city,
							cid: that.defaultData[index].cid,
							defult_form_cost: that.defaultData[index].defult_form_cost,
						}
					};
					let res = await saveSingleDefaultCost(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.getDefaultAdvCost();
					}
				}, 500)

			},
			saveQuotationList() {
				let that = this;
				that.$Modal.confirm({
					title: '确定保存吗？',
					onOk: async () => {
						that.throttle(async function() {
							let quotationData = that.quotationData;
							let quotationTime = that.quotationTime;

							quotationData.shift(); //去掉数组第一项合计项
							let res = await saveQuotationList(that, {
								list: quotationData,
								quotationTime: quotationTime,
								token: that.token,
							});
							if (res.code == 1) {
								that.$Message.success(res.msg);
								this.quotationSearch();
							}
						}, 500)
					}
				})
			},
			settleCost() {
				let that = this;
				//遍历下看是否有0的成本
				let arr = that.quotationData;
				for (let i = 0, len = arr.length; i < len; i++) {
					if (arr[i].quotation_average_money == 0) {
						that.$Message.error('还有结算金额为0的数据，请检查');
						return;
					}
				}
				that.$Modal.confirm({
					title: '确定要结算吗？',
					onOk: async () => {
						that.throttle(async function() {
							let quotationData = that.quotationData;
							let quotationTime = that.quotationTime;
							quotationData.shift(); //去掉数组第一项合计项
							let res = await settleCost(that, {
								list: quotationData,
								quotationTime: quotationTime,
								token: that.token,
							});
							if (res.code == 1) {
								that.$Message.success(res.msg);
								this.quotationSearch();
							}
						}, 500)
					}
				})
			},
			formatMoney(money) {
				return (money * 1.0 / 100).toFixed(2)
			},
			changeQuotationAverageMoney(e, index) {
				let item = this.quotationData[index];

				this.quotationData[index].quotation_money = item.quotation_average_money * item.form_nums ? item
					.quotation_average_money * item.form_nums : '';
			},
			changeQuotationCost(e, index) {
				let item = this.quotationData[index];
				this.quotationData[index].quotation_average_money = item.quotation_money / item.form_nums ? item
					.quotation_money / item.form_nums : '';
			},
			changeFormCost(e, index) {
				let item = this.advData[index];

				this.advData[index].adv_cost = item.form_cost * item.form_nums ? item.form_cost * item.form_nums : '';
			},
			changeAdvCost(e, index) {
				let item = this.advData[index];
				this.advData[index].form_cost = item.adv_cost / item.form_nums ? item.adv_cost / item.form_nums : '';
			},
			changeQuotationForm() {
				this.quotationForm.edit_quotation_money = this.quotationForm.edit_quotation_average_money * this
					.quotationForm.form_nums ? this.quotationForm.edit_quotation_average_money * this.quotationForm
					.form_nums : '';
			},
			changeAverageQuotationForm() {
				this.quotationForm.edit_quotation_average_money = this.quotationForm.edit_quotation_money / this
					.quotationForm.form_nums ? this.quotationForm.edit_quotation_money / this.quotationForm.form_nums : '';
			},
			exportData() {
				this.$refs.mytable.exportCsv({
					filename: "报价表", //导出Excel的名字
					original: false,
					columns: this.quotationColumns, //table的每一列
					// orderid是订单编号，此处进行转换，因为orderid过长，不转换会变成科学计数法的格式
					data: this.quotationData.map(k => {
						k.orderid = "\t" + k.orderid;
						return k;
					})
				});
			},
		},
	}
</script>
<style scoped lang="less">
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}
</style>